import betsafe from "../images/betsafe.png"
import casumo from "../images/casumo.png"
import mrGreen from "../images/mrgreen.jpg"
import leo from "../images/leo.png"
import jackpotCity from "../images/jackpot_city.png"
import slots from "../images/slots.png"
import slotsLV from "../images/slotslv.png"
import ragingBullCasino from "../images/Raging_Bull.jpg"
import bitDreamsCasino from "../images/BitDreams-Casino.png"
import grandFortuneCasino from "../images/grand_fortune_casino.png"
import planet7Casino from "../images/Planet7-Casino.webp"
import bitKingz from "../images/Bitkingz.jpg"
import wildCardCityCasino from "../images/WildCard-City-Logo.jpg"
import tangiers from "../images/tangiers-casino.png"
import vegadreamCasino from "../images/VegaDream.png"
import highflyerCasino from "../images/High_Flyer.png"
import dreamVegas from "../images/dreamvegas.jpg"
import cashCabin from "../images/cashcabin-casino.png"
import betMGM from "../images/BetMGM.webp"
import img888Casino from "../images/888Casino.png"
import goldenNugget from "../images/Golden_Nugget192.png"
import sugarHouse from "../images/sugarhouse_online_casino192.png"
import partyCasino from "../images/party-casino.jpg"
import fanDuel from "../images/fanduel.png"
import resortCasino from "../images/resorts-casino192.png"
import moheganSun  from "../images/Mohegan-Sun-Logo192.png"
import betRivers  from "../images/rivers_casino_192.png"
import bet365  from "../images/bet365-casino-logo-300x190.png"
import onlnecasino  from "../images/onlnecasino_logo.png"
import unibet  from "../images/Unibet192.png"
import wynnBetCasino  from "../images/WynnBetCasino.png"
import resortCasinoSquare from "../images/resort-casino-square.png"
import betMGMSquare from "../images/betMGMsquare.png"
import onlnecasinosquare from "../images/onlnecasinosquare.png"

export const highlightCasino = {
  casino: "",
  img: onlnecasinosquare,
  alt: "",
  highlight: "",
  nonHighlight: "",
  line2: "",
  deposit: "",
  play: "",
  score: "",
  stars: 0,
  redirect:
    "",
}

export const highlightCasinoAU = {
  casino: "",
  img: onlnecasinosquare,
  alt: "",
  highlight: "",
  nonHighlight: "",
  line2: "",
  deposit: "",
  play: "",
  score: "",
  stars: 0,
  redirect:
    "",
}

export const highlightCasinoCA = {
  casino: "",
  img: onlnecasinosquare,
  alt: "",
  highlight: "",
  nonHighlight: "",
  line2: "",
  deposit: "",
  play: "",
  score: "",
  stars: 0,
  redirect:
    "",
}

export const highlightCasinoUS = {
  casino: "Bet MGM",
  img: betMGMSquare,
  alt: "Bet MGM",
  highlight: "100% Bonus",
  nonHighlight: "up to $1000",
  line2: "+ $25 Token",
  deposit: "$100",
  play: "$200",
  score: "10",
  stars: 5,
  redirect:
    "https://captrkr.com/track/3eb59d27-258d-4426-898a-60546238922a?type=seo",
}

export const highlightCasinoUSPA = {
  casino: "Bet MGM",
  img: betMGMSquare,
  alt: "Bet MGM",
  highlight: "100% Bonus",
  nonHighlight: "up to $1000",
  line2: "+ $25 Token",
  deposit: "$100",
  play: "$200",
  score: "10",
  stars: 5,
  redirect:
    "https://captrkr.com/track/bd9aaf7f-f53a-439a-a7b0-210c7880f1ea?type=seo",
}

export const highlightCasinoUSMI = {
  casino: "Bet MGM",
  img: betMGMSquare,
  alt: "Bet MGM",
  highlight: "100% Bonus",
  nonHighlight: "up to $1000",
  line2: "+ $25 Token",
  deposit: "$100",
  play: "$200",
  score: "10",
  stars: 5,
  redirect:
    "https://captrkr.com/track/bd9aaf7f-f53a-439a-a7b0-210c7880f1ea?type=seo",
}

export const highlightCasinoUSNJ = {
    casino: "RESORT CASINO",
    img: resortCasinoSquare,
    alt: "RESORT CASINO",
    highlight: "100% Bonus",
    nonHighlight: " up to $1,000",
    line2: " coupon code: DEPOSIT1 ",
    deposit: "$100",
    play: "$200",
    score: "9.8",
    stars: 5,
    redirect:
      "https://captrkr.com/track/a9d66a6f-e3f6-4370-ba5b-6174b33ebd6e?type=seo",
}

export const highlightCasinoUSCO = {
  casino: "",
  img: onlnecasinosquare,
  alt: "",
  highlight: "",
  nonHighlight: "",
  line2: "",
  deposit: "",
  play: "",
  score: "",
  stars: 0,
  redirect:
    "",
}

export const highlightCasinoUSIN = {
  casino: "",
  img: onlnecasinosquare,
  alt: "",
  highlight: "",
  nonHighlight: "",
  line2: "",
  deposit: "",
  play: "",
  score: "",
  stars: 0,
  redirect:
    "",
}

export const casinoList = [
]

export const casinoListAU = [
]

export const casinoListCA = [
]

export const casinoListUS = [
  {
    casino: "Fan Duel Casino",
    img: fanDuel,
    alt: "Fan Duel Casino",
    highlight: "100% Bonus ",
    nonHighlight: " Cashback",
    line2: " Up to $1,000",
    deposit: "$100",
    play: "$200",
    score: "9.7",
    stars: 5,
    redirect:
      "https://captrkr.com/track/d6fa5ef8-40c3-4b90-8cc9-80321076e412?type=seo",
  },
]

export const casinoListUSNJ = [

  {
    casino: "Sugar House",
    img: sugarHouse,
    alt: "Sugar House",
    highlight: "100% Bonus",
    nonHighlight: " up to $250",
    line2: "(code: 250MATCH)",
    deposit: "$100",
    play: "$200",
    score: "9.8",
    stars: 5,
    redirect:
      "https://captrkr.com/track/5bae6564-a466-4ef3-bcf0-21b96d46a4ab?type=seo",
  },
  {
    casino: "Mohegan Sun ",
    img: moheganSun,
    alt: "Mohegan Sun ",
    highlight: "100% Bonus ",
    nonHighlight: "up to $1,000",
    line2: "coupon code: MOHEGAN",
    deposit: "$100",
    play: "$200",
    score: "9.7",
    stars: 5,
    redirect:
      "https://captrkr.com/track/533b6d37-856d-4505-9fbd-da7c84c51f0e?type=seo",
  },
  {
	  casino: "Bet MGM",
	  img: betMGM,
	  alt: "Bet MGM",
	  highlight: "100% Bonus",
	  nonHighlight: "up to $1000",
	  line2: "+ $25 Token",
	  deposit: "$100",
	  play: "$200",
	  score: "9.6",
	  stars: 5,
	  redirect:
		"https://captrkr.com/track/3eb59d27-258d-4426-898a-60546238922a?type=seo",
	},

  {
    casino: "Party Casino",
    img: partyCasino,
    alt: "Party Casino",
    highlight: "100% Bonus",
    nonHighlight: "up to $1000",
    line2: "+ 25 Free Spins",
    deposit: "$100",
    play: "$200",
    score: "9.5",
    stars: 5,
    redirect:
      "https://captrkr.com/track/a79bc4ac-0ed8-40bc-bf3f-55bf3baa1d16?type=seo",
  },
  {
    casino: "888",
    img: img888Casino,
    alt: "888",
    highlight: "$20 No Deposit ",
    nonHighlight: "120% up to $500",
    line2: "Welcome Bonus",
    deposit: "$100",
    play: "$120",
    score: "9.4",
    stars: 5,
    redirect:
      "https://captrkr.com/track/e48d4fcc-8a3c-4571-8cbb-c3646c4aba77?type=seo",
  },
  {
    casino: "Golden Nugget",
    img: goldenNugget,
    alt: "Golden Nugget",
    highlight: "100% Bonus ",
    nonHighlight: "up to $1,000",
    line2: "+ 200 Free Spins",
    deposit: "$100",
    play: "$200",
    score: "9.3",
    stars: 5,
    redirect:
      "https://captrkr.com/track/a3859c3b-2413-4226-8541-53ccd442e8c8?type=seo",
  },
  {
    casino: "FanDuel",
    img: fanDuel,
    alt: "FanDuel",
    highlight: "100% Bonus ",
    nonHighlight: " / Up to $1,000",
    line2: " Cashback on first 24 hours",
    deposit: "$100",
    play: "$200",
    score: "9.2",
    stars: 5,
    redirect:
      "https://captrkr.com/track/18821411-f1de-41c0-a6ff-7376ceff039b?type=ppc",
  },
  {
    casino: "UniBet",
    img: unibet,
    alt: "UniBet",
    highlight: "Free",
    nonHighlight: " $10 bonus / 100% ",
    line2: "Casino bonus up to $500",
    deposit: "$100",
    play: "$200",
    score: "9.1",
    stars: 5,
    redirect:
      "https://captrkr.com/track/a88146a1-5de5-4602-9c36-31d56ad5beeb?type=seo",
  },
]

export const casinoListUSPA = [

  {
    casino: "BetRivers",
    img: betRivers,
    alt: "BetRivers",
    highlight: "100% ",
    nonHighlight: "up to $250",
    line2: "(code: 250MATCH)",
    deposit: "$100",
    play: "$200",
    score: "9.4",
    stars: 5,
    redirect:
      "https://captrkr.com/track/6c5f9eba-8a6b-4b92-bfa5-8c17efd5ff49?type=seo",
  },
  {
    casino: "Fan Duel Casino",
    img: fanDuel,
    alt: "Fan Duel Casino",
    highlight: "100% Cashback ",
    nonHighlight: " up to $1,000",
    line2: "",
    deposit: "$100",
    play: "$200",
    score: "9.8",
    stars: 5,
    redirect:
      "https://captrkr.com/track/d6fa5ef8-40c3-4b90-8cc9-80321076e412?type=seo",
  },
  {
    casino: "UniBet",
    img: unibet,
    alt: "UniBet",
    highlight: "Free",
    nonHighlight: " $10 bonus / 100% ",
    line2: "Casino bonus up to $500",
    deposit: "$100",
    play: "$200",
    score: "9.7",
    stars: 5,
    redirect:
      "https://captrkr.com/track/22be0c84-81c3-4fe8-b85e-c745094a398c?type=seo",
  },
]

export const casinoListUSMI = [
  {
    casino: "BetRivers",
    img: betRivers,
    alt: "BetRivers",
    highlight: "100% ",
    nonHighlight: "up to $250",
    line2: "(code: 250MATCH)",
    deposit: "$100",
    play: "$200",
    score: "9.8",
    stars: 5,
    redirect:
      "https://captrkr.com/track/89f1742a-45c5-4713-8f7b-680966508d1e?type=seo",
  },
  {
    casino: "Fan Duel Casino",
    img: fanDuel,
    alt: "Fan Duel Casino",
    highlight: "100% Cashback ",
    nonHighlight: " up to $1,000",
    line2: "",
    deposit: "$100",
    play: "$200",
    score: "9.7",
    stars: 5,
    redirect:
      "https://captrkr.com/track/d6fa5ef8-40c3-4b90-8cc9-80321076e412?type=seo",
  },
  {
    casino: "WynnBet Casino",
    img: wynnBetCasino,
    alt: "WynnBet Casino",
    highlight: "100% bonus",
    nonHighlight: " up to $1,000",
    line2: "",
    deposit: "$100",
    play: "$200",
    score: "9.6",
    stars: 5,
    redirect:
      "https://captrkr.com/track/e5c6866c-4caf-4fc6-a795-4b890ea24820?type=seo",
  },
]

export const casinoListUSCO = [

]

export const casinoListUSIN = [

]

export default {
  casinoList,
}
